import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "blue_box _full" }
const _hoisted_3 = { class: "box_tit _flex" }
const _hoisted_4 = {
  key: 0,
  class: "group_info"
}
const _hoisted_5 = { class: "info" }
const _hoisted_6 = { class: "info" }
const _hoisted_7 = { class: "info" }
const _hoisted_8 = { class: "info" }
const _hoisted_9 = { class: "info" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "total_rank" }
const _hoisted_12 = { class: "common_table custom_scroll" }
const _hoisted_13 = { class: "cnt" }
const _hoisted_14 = { class: "rank_head" }
const _hoisted_15 = { class: "common_table custom_scroll" }
const _hoisted_16 = { class: "cnt" }
const _hoisted_17 = { class: "cnt" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  key: 1,
  class: "common_table custom_scroll citizen_list"
}
const _hoisted_20 = { class: "table_head" }
const _hoisted_21 = { type: "button" }
const _hoisted_22 = { class: "multi_table" }
const _hoisted_23 = { class: "left_table" }
const _hoisted_24 = { class: "list_num cnt" }
const _hoisted_25 = {
  key: 1,
  class: "no_citizen"
}
const _hoisted_26 = { class: "custom_scroll" }
const _hoisted_27 = { style: {"min-width":"80px"} }
const _hoisted_28 = { style: {"min-width":"80px"} }
const _hoisted_29 = { class: "checkbox_wrap cnt p_5 checkbox_wrap2" }
const _hoisted_30 = ["for"]
const _hoisted_31 = ["id", "onUpdate:modelValue", "onChange"]
const _hoisted_32 = { class: "cnt" }
const _hoisted_33 = {
  key: 1,
  class: "no_citizen"
}
const _hoisted_34 = ["colspan"]
const _hoisted_35 = { class: "right_table" }
const _hoisted_36 = { class: "cnt" }
const _hoisted_37 = { class: "cnt" }
const _hoisted_38 = { class: "cnt" }
const _hoisted_39 = { class: "cnt" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = {
  key: 1,
  class: "no_citizen"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Left = _resolveComponent("Left")!
  const _component_PageBtn = _resolveComponent("PageBtn")!
  const _component_ModalDefault = _resolveComponent("ModalDefault")!
  const _component_ActionCitizenModal = _resolveComponent("ActionCitizenModal")!
  const _component_ActionCitizenAddModal = _resolveComponent("ActionCitizenAddModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createVNode(_component_Left),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[11] || (_cache[11] = _createElementVNode("h2", null, "액션 그룹 상세", -1)),
          _createElementVNode("button", {
            class: "default_btn _gray",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.router.replace('/action/group')))
          }, "그룹 목록")
        ]),
        ($setup.state.groupInfo)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", null, [
                _cache[12] || (_cache[12] = _createElementVNode("span", null, "제목", -1)),
                _createElementVNode("div", _hoisted_5, _toDisplayString($setup.state.groupInfo?.title), 1)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", null, [
                  _cache[13] || (_cache[13] = _createElementVNode("span", null, "상태", -1)),
                  _createElementVNode("div", _hoisted_6, [
                    ($setup.state.groupInfo.state === 1)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "table_btn _blue",
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.stateChange && $setup.stateChange(...args)))
                        }, "진행중"))
                      : (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: "table_btn _gray",
                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.stateChange && $setup.stateChange(...args)))
                        }, "종료"))
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[14] || (_cache[14] = _createElementVNode("span", null, "등록일", -1)),
                  _createElementVNode("div", _hoisted_7, _toDisplayString($setup.CommonUtils.dateFormatYYMMDD(new Date($setup.state.groupInfo.createDate))), 1)
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", null, [
                  _cache[15] || (_cache[15] = _createElementVNode("span", null, "활동 기간", -1)),
                  _createElementVNode("div", _hoisted_8, _toDisplayString($setup.CommonUtils.dateFormatYYMMDD(new Date($setup.state.groupInfo.startDate))) + " ~ " + _toDisplayString($setup.CommonUtils.dateFormatYYMMDD(new Date($setup.state.groupInfo.endDate))), 1)
                ]),
                _createElementVNode("div", null, [
                  _cache[16] || (_cache[16] = _createElementVNode("span", null, "출석 주차", -1)),
                  _createElementVNode("div", _hoisted_9, [
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      placeholder: "주차 개수를 입력해주세요",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.state.groupInfo.cntRound) = $event)),
                      disabled: $setup.citizen.totalLength > 0
                    }, null, 8, _hoisted_10), [
                      [_vModelText, $setup.state.groupInfo.cntRound]
                    ]),
                    (!($setup.citizen.totalLength > 0))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "table_btn _blue",
                          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.saveRound && $setup.saveRound(...args)))
                        }, "저장"))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", null, [
            _cache[19] || (_cache[19] = _createElementVNode("div", { class: "rank_head" }, [
              _createElementVNode("p", null, "출석 현황")
            ], -1)),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("table", null, [
                _cache[17] || (_cache[17] = _createElementVNode("colgroup", null, [
                  _createElementVNode("col", { style: {"width":"100px"} }),
                  _createElementVNode("col", { style: {"width":"40px"} })
                ], -1)),
                _cache[18] || (_cache[18] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, "이름"),
                    _createElementVNode("th", null, "참여 인원")
                  ])
                ], -1)),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.roundList, (item, idx) => {
                    return (_openBlock(), _createElementBlock("tr", null, [
                      _createElementVNode("td", null, _toDisplayString(item.name), 1),
                      _createElementVNode("td", _hoisted_13, _toDisplayString(item.cnt), 1)
                    ]))
                  }), 256))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_14, [
              _cache[20] || (_cache[20] = _createElementVNode("p", null, "액션활동 현황", -1)),
              _createElementVNode("button", {
                class: "default_btn _blue",
                onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.router.push(`/action/${$setup.state.groupIdx}/state`)))
              }, "관리")
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("table", null, [
                _cache[21] || (_cache[21] = _createElementVNode("colgroup", null, [
                  _createElementVNode("col", { style: {"width":"100px"} }),
                  _createElementVNode("col", { style: {"width":"40px"} }),
                  _createElementVNode("col", { style: {"width":"40px"} })
                ], -1)),
                _cache[22] || (_cache[22] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, "이름"),
                    _createElementVNode("th", null, "참여 인원"),
                    _createElementVNode("th", null, "상세")
                  ])
                ], -1)),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.stateList, (item, idx) => {
                    return (_openBlock(), _createElementBlock("tr", null, [
                      _createElementVNode("td", null, _toDisplayString(item.name), 1),
                      _createElementVNode("td", _hoisted_16, _toDisplayString(item.cntEntire), 1),
                      _createElementVNode("td", _hoisted_17, [
                        _createElementVNode("button", {
                          class: "default_btn _blue",
                          onClick: ($event: any) => ($setup.router.push(`/action/${$setup.state.groupIdx}/state/${item.idx}`))
                        }, " 상세 ", 8, _hoisted_18)
                      ])
                    ]))
                  }), 256))
                ])
              ])
            ])
          ])
        ]),
        ($setup.state.roundList.length > 0 && $setup.state.stateList.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_20, [
                  _cache[23] || (_cache[23] = _createElementVNode("p", null, "종합 실적 순위", -1)),
                  _createElementVNode("div", null, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "default_btn _blue",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.state.isShowCitizenModal = true))
                    }, "회원 등록"),
                    _createElementVNode("button", _hoisted_21, [
                      _createElementVNode("img", {
                        src: "img/excel_icon.png",
                        alt: " 엑셀 다운로드",
                        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => ($setup.excelDownload && $setup.excelDownload(...args)))
                      })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("table", _hoisted_23, [
                    _cache[25] || (_cache[25] = _createElementVNode("colgroup", null, [
                      _createElementVNode("col", { style: {"width":"60px"} }),
                      _createElementVNode("col", { style: {"width":"120px"} }),
                      _createElementVNode("col", { style: {"width":"auto"} })
                    ], -1)),
                    _cache[26] || (_cache[26] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, "순위"),
                        _createElementVNode("th", null, "이름"),
                        _createElementVNode("th", null, "닉네임")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      ($setup.citizen.list && $setup.citizen.list.length > 0)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.citizen.list, (item, idx) => {
                            return (_openBlock(), _createElementBlock("tr", null, [
                              _createElementVNode("td", _hoisted_24, _toDisplayString(($setup.citizen.currentPage - 1) * $setup.citizen.perPage + (idx + 1)), 1),
                              _createElementVNode("td", null, _toDisplayString(item.member.name), 1),
                              _createElementVNode("td", null, _toDisplayString(item.nickname), 1)
                            ]))
                          }), 256))
                        : (_openBlock(), _createElementBlock("tr", _hoisted_25, [...(_cache[24] || (_cache[24] = [
                            _createElementVNode("td", { colspan: "2" }, null, -1)
                          ]))]))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("table", null, [
                      _createElementVNode("colgroup", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.roundList, (item) => {
                          return (_openBlock(), _createElementBlock("col", _hoisted_27))
                        }), 256)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.stateList, (item) => {
                          return (_openBlock(), _createElementBlock("col", _hoisted_28))
                        }), 256))
                      ]),
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.roundList, (item) => {
                            return (_openBlock(), _createElementBlock("th", null, _toDisplayString(item.name), 1))
                          }), 256)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.stateList, (item) => {
                            return (_openBlock(), _createElementBlock("th", null, _toDisplayString(item.name), 1))
                          }), 256))
                        ])
                      ]),
                      _createElementVNode("tbody", null, [
                        ($setup.citizen.list && $setup.citizen.list.length > 0)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.citizen.list, (item) => {
                              return (_openBlock(), _createElementBlock("tr", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.roundList, (round) => {
                                  return (_openBlock(), _createElementBlock("td", _hoisted_29, [
                                    _createElementVNode("label", {
                                      for: `chk_${item.idx}_${round.brIdx}`,
                                      onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"]))
                                    }, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "checkbox",
                                        id: `chk_${item.idx}_${round.brIdx}`,
                                        "onUpdate:modelValue": ($event: any) => ((round.isDone) = $event),
                                        "true-value": 1,
                                        "false-value": 0,
                                        onChange: ($event: any) => ($setup.changeCitizenRound(item, round))
                                      }, null, 40, _hoisted_31), [
                                        [_vModelCheckbox, round.isDone]
                                      ]),
                                      _cache[27] || (_cache[27] = _createElementVNode("em", null, null, -1))
                                    ], 8, _hoisted_30)
                                  ]))
                                }), 256)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.stateList, (state) => {
                                  return (_openBlock(), _createElementBlock("td", _hoisted_32, _toDisplayString(state.isDone), 1))
                                }), 256))
                              ]))
                            }), 256))
                          : (_openBlock(), _createElementBlock("tr", _hoisted_33, [
                              _createElementVNode("td", {
                                class: "cnt",
                                colspan: $setup.state.roundList.length + $setup.state.stateList.length
                              }, "등록된 회원이 없습니다.", 8, _hoisted_34)
                            ]))
                      ])
                    ])
                  ]),
                  _createElementVNode("table", _hoisted_35, [
                    _cache[29] || (_cache[29] = _createElementVNode("colgroup", null, [
                      _createElementVNode("col", { style: {"width":"50px"} }),
                      _createElementVNode("col", { style: {"width":"80px"} }),
                      _createElementVNode("col", { style: {"width":"40px"} }),
                      _createElementVNode("col", { style: {"width":"50px"} })
                    ], -1)),
                    _cache[30] || (_cache[30] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, "전체 출석"),
                        _createElementVNode("th", null, "전체 액션활동 참여"),
                        _createElementVNode("th", null, "합계"),
                        _createElementVNode("th", null, "수정")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      ($setup.citizen.list && $setup.citizen.list.length > 0)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.citizen.list, (item, idx) => {
                            return (_openBlock(), _createElementBlock("tr", null, [
                              _createElementVNode("td", _hoisted_36, _toDisplayString(item.cntEntire), 1),
                              _createElementVNode("td", _hoisted_37, _toDisplayString(item.cntEntireChallenge), 1),
                              _createElementVNode("td", _hoisted_38, _toDisplayString(item.sum), 1),
                              _createElementVNode("td", _hoisted_39, [
                                _createElementVNode("button", {
                                  class: "default_btn _blue",
                                  onClick: ($event: any) => ($setup.showModifyCitizen(item))
                                }, "수정", 8, _hoisted_40)
                              ])
                            ]))
                          }), 256))
                        : (_openBlock(), _createElementBlock("tr", _hoisted_41, [...(_cache[28] || (_cache[28] = [
                            _createElementVNode("td", { colspan: "2" }, null, -1)
                          ]))]))
                    ])
                  ])
                ])
              ]),
              ($setup.citizen.list.length !== 0)
                ? (_openBlock(), _createBlock(_component_PageBtn, {
                    key: 0,
                    currentPage: $setup.citizen.currentPage,
                    totalLength: $setup.citizen.totalLength,
                    perPage: $setup.citizen.perPage,
                    onOnPaging: $setup.handlePageCitizen
                  }, null, 8, ["currentPage", "totalLength", "perPage", "onOnPaging"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    ($setup.state.isShowModal)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 0,
          type: $setup.modal.tab,
          title: $setup.modal.title,
          content: $setup.modal.content,
          onClose: _cache[9] || (_cache[9] = ($event: any) => ($setup.state.isShowModal = false)),
          onCallback: $setup.callBackModal
        }, null, 8, ["type", "title", "content", "onCallback"]))
      : _createCommentVNode("", true),
    ($setup.state.isShowCitizenModal)
      ? (_openBlock(), _createBlock(_component_ActionCitizenModal, {
          key: 1,
          idx: $setup.state.groupIdx,
          onClose: $setup.closeCitizenModal,
          onChange: $setup.getCitizenList
        }, null, 8, ["idx", "onClose", "onChange"]))
      : _createCommentVNode("", true),
    ($setup.state.isShowNicknameModal)
      ? (_openBlock(), _createBlock(_component_ActionCitizenAddModal, {
          key: 2,
          data: $setup.citizen.selectCitizen,
          isEdit: true,
          onClose: _cache[10] || (_cache[10] = ($event: any) => ($setup.state.isShowNicknameModal = false)),
          onCallback: $setup.modifyCitizen
        }, null, 8, ["data", "onCallback"]))
      : _createCommentVNode("", true)
  ], 64))
}